import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography } from 'antd';
import AccountDetailForm from '../../../../components/mobile/sign-up/AccountDetailForm';
import { ReactComponent as EmployeeSvg } from '../../../../assets/icons/sign-up/employees.svg';

const { Title, Paragraph } = Typography;

const styles = {
  title: {
    fontWeight: "300",
    fontSize: "20px",
    lineHeight: "24px",
    textAlign: "center",
    color: "#404047",
    marginBottom: 10
  },
  subtitle: {
    fontWeight: "400",
    fontSize: "18px",
    lineHeight: "28px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    textTransform: "capitalize",
    color: "#15A9E1",
    marginBottom: 33,
  }
}

function MobileAccountInfoScreen() {
  const { t } = useTranslation(['sign-up', 'common']);
  const history = useHistory();

  const onConfirm = () => {
    history.push('/sign-up/guest/method/personal-info');
  }

  return (
    <>
      <Box display="flex" justifyContent="center">
        <EmployeeSvg style={{ margin: '20', maxWidth: '80%' }} />
      </Box>
      <Box textAlign="center">
        <Row gutter={[0, 24]}>
          <Col xs={24}>
            <Title level={4} style={styles.title}>
              {t('sign-up:guest.signUpForAlemHealth')}
            </Title>
            <Row justify="center">
              <Paragraph style={styles.subtitle}>
                {t('sign-up:guest.accountDetail')}
              </Paragraph>
            </Row>
          </Col>
        </Row>
      </Box>
      <AccountDetailForm
        onSubmit={onConfirm}
        onSubmitBtnText={t('common:button.signUp')}
      />
    </>
  );
}

export default MobileAccountInfoScreen;
